import gql from "graphql-tag";

export const UPDATE_TEMPLATE_COSTUME_ATTRIBUTE = gql`
  mutation UpdateCostumeAttribute(
    $filter: UniqCostumeAttributeFilterInput!
    $update: CostumeAttributeUpdateInput!
  ) {
    updateCostumeAttribute(filter: $filter, update: $update) {
      id
    }
  }
`;
